import React, { useState, useEffect, useContext, useRef } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import Get from "../../Get";
import { generateEAN13, generateItemReference } from "../../../../utils/ean13Generator";

function ArticulosCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const URL_ARTICULOS = import.meta.env.VITE_URL_ARTICULOS;
  const URL_INVENTARIOS = import.meta.env.VITE_URL_INVENTARIOS;
  const URL_LINEAS = import.meta.env.VITE_URL_LINEAS;
  const URL_MARCAS = import.meta.env.VITE_URL_MARCAS;
  const URL_FAMILIAS = import.meta.env.VITE_URL_FAMILIAS;
  const URL_COLECCIONES = import.meta.env.VITE_URL_COLECCIONES;
  const URL_PROVEEDORES = import.meta.env.VITE_URL_PROVEEDORES;
  const URL_COLORES = import.meta.env.VITE_URL_COLORES;
  const URL_TALLAS = import.meta.env.VITE_URL_TALLAS;
  const URL_ARTICULOS_PROPORCION =
    import.meta.env.VITE_URL_ARTICULOS_PROPORCION;

  const [codigo, setCodigo] = useState("");
  const [nombre, setNombre] = useState("");
  const [piezasPorCaja, setPiezasPorCaja] = useState("");
  const [costoUSD, setCostoUSD] = useState("");
  const [costoMX, setCostoMX] = useState("");
  const [venta, setVenta] = useState("");
  const [utilidadP, SetUtilidadP] = useState();
  const [utilidadM, setUtilidadM] = useState();
  const [lista1, setLista1] = useState("");
  const [lista2, setLista2] = useState("");
  const [lista3, setLista3] = useState("");
  const [lista4, setLista4] = useState("");
  const [codigoSAT, setCodigoSAT] = useState("NA");
  const [codigoUnidad, setCodigoUnidad] = useState("PZ");
  const [observaciones, setObservaciones] = useState("NA");
  const [lineas, setLineas] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [familias, setFamilias] = useState([]);
  const [colecciones, setColecciones] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [precioEsp, setPrecioEsp] = useState("");
  const [ano, setAno] = useState("");
  const [EAN, setEAN] = useState("");
  const [RFID, setRFID] = useState("");
  const [selectedLinea, setSelectedLinea] = useState("");
  const [selectedMarca, setSelectedMarca] = useState("");
  const [selectedFamilia, setSelectedFamilia] = useState("");
  const [selectedColeccion, setSelectedColeccion] = useState("");
  const [selectedProveedor, setSelectedProveedor] = useState("");

  // For "Add New" toggle and input state
  const [isAddingLinea, setIsAddingLinea] = useState(false);
  const [newLineaName, setNewLineaName] = useState("");

  const [isAddingMarca, setIsAddingMarca] = useState(false);
  const [newMarcaName, setNewMarcaName] = useState("");

  const [isAddingFamilia, setIsAddingFamilia] = useState(false);
  const [newFamiliaName, setNewFamiliaName] = useState("");

  const [isAddingColeccion, setIsAddingColeccion] = useState(false);
  const [newColeccionName, setNewColeccionName] = useState("");

  const [colores, setColores] = useState([]);
  const [tallas, setTallas] = useState([]);
  const [customSizeOrder, setCustomSizeOrder] = useState([]);

  const [modalColores, setModalColores] = useState(false);
  const toggleColores = () => setModalColores(!modalColores);
  const [arrayColores, setArrayColores] = useState([]);

  const [modalTallas, setModalTallas] = useState(false);
  const toggleTallas = () => setModalTallas(!modalTallas);
  const [arrayTallas, setArrayTallas] = useState([]);
  const [eans, setEans] = useState([]);

  const [amounts, setAmounts] = useState([]);
  const [validaBoton, setValidaBoton] = useState(true);
  const submittingRef = useRef(false);

  const [file, setFile] = useState(null);
  const URL_FILEPOST = import.meta.env.VITE_URL_UPPROFILE;

  let hoy = new Date();
  hoy.setDate(hoy.getDate() - 3650);
  const year = hoy.getFullYear();
  const years = Array.from(new Array(40), (val, index) => index + year);

  const [lastChanged, setLastChanged] = useState(null);

  // Single useEffect that handles both cases
  useEffect(() => {
    // Check which value changed and update accordingly
    if (lastChanged === "utilidadP") {
      // Calculate based on utilidadP
      const newUtilidadM = parseFloat(costoMX) * (utilidadP / 100);
      setUtilidadM(newUtilidadM);

      // Calculate venta price
      const newVenta = parseFloat(costoMX) + newUtilidadM;
      setVenta(newVenta.toFixed(2));
      setLista1(newVenta.toFixed(2));
      setLista2(newVenta.toFixed(2));
      setLista3(newVenta.toFixed(2));
      setLista4(newVenta.toFixed(2));
    } else if (lastChanged === "utilidadM") {
      // Calculate based on utilidadM
      const newUtilidadP = ((utilidadM / costoMX) * 100).toFixed(2);
      SetUtilidadP(newUtilidadP);

      // Calculate venta price
      const newVenta = parseFloat(costoMX) + utilidadM;
      setVenta(newVenta.toFixed(2));
      setLista1(newVenta.toFixed(2));
      setLista2(newVenta.toFixed(2));
      setLista3(newVenta.toFixed(2));
      setLista4(newVenta.toFixed(2));
    }
  }, [costoMX, utilidadP, utilidadM, lastChanged]);

  useEffect(() => {
    if (codigo.trim()) {
      setEAN(codigo);
      setRFID(generateEAN13(generateItemReference(codigo, "", "")));
    }
  }, [codigo]);

  useEffect(() => {
    axios
      .get(URL_LINEAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allLineas = res.data;
        setLineas(allLineas);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_MARCAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allMarcas = res.data;
        setMarcas(allMarcas);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_FAMILIAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allFamilias = res.data;
        setFamilias(allFamilias);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_COLECCIONES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColecciones = res.data;
        setColecciones(allColecciones);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(`${URL_PROVEEDORES}Tipo/China`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allProveedores = res.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_COLORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColores = res.data;
        setColores(allColores);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_TALLAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTallas = res.data;
        setTallas(allTallas);

        const customeSizeOrder = allTallas
          .map((t) => t.name)
        setCustomSizeOrder(customeSizeOrder);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function coloresSeleccionados(checked, color) {
    if (checked) {
      setArrayColores([...arrayColores, { id: color._id, name: color.name, prefijo: color.prefijo }]);
    } else {
      const values = [...arrayColores];
      // Handle both cases: color object with _id (from original list) or selectedColor object with id (from selected list)
      const colorId = color._id || color.id;
      const indexToRemove = values.findIndex((t) => t.id === colorId);

      if (indexToRemove !== -1) {
        values.splice(indexToRemove, 1);
        setArrayColores(values);
      }
    }
  }

  function tallasSeleccionados(checked, talla) {
    if (checked) {
      setArrayTallas([...arrayTallas, { id: talla._id, name: talla.name }]);
    } else {
      const values = [...arrayTallas];
      // Handle both cases: talla object with _id (from original list) or selectedTalla object with id (from selected list)
      const tallaId = talla._id || talla.id;
      const indexToRemove = values.findIndex((t) => t.id === tallaId);

      if (indexToRemove !== -1) {
        values.splice(indexToRemove, 1);
        setArrayTallas(values);
      }
    }
  }

  const handleEanChange = (sizeId, colorId, value) => {
    setEans((prev) => {
      const existing = prev.find(
        (entry) => entry.sizeId === sizeId && entry.colorId === colorId
      );
      if (existing) {
        return prev.map((entry) =>
          entry.sizeId === sizeId && entry.colorId === colorId
            ? { ...entry, ean: value }
            : entry
        );
      } else {
        return [...prev, { sizeId, colorId, ean: value }];
      }
    });
  };

  const saveArticulos = async (event) => {
    event.preventDefault();
    const result = await Swal.fire({
      title: "¿Estás seguro?",
      text: "¿Deseas guardar este artículo?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, guardar",
      cancelButtonText: "Cancelar",
    });
    if (!result.isConfirmed) return;
    if (submittingRef.current) return;
    submittingRef.current = true;
    setValidaBoton(false);

    // Solo guardar colores/tallas que tienen al menos una proporción capturada
    const amountsConDatos = amounts.filter(
      (a) => parseFloat(a.cantidad) > 0
    );
    const arrayColoresOfIds = [
      ...new Set(amountsConDatos.map((a) => a.colorId)),
    ];
    const arrayTallasOfIds = [
      ...new Set(amountsConDatos.map((a) => a.sizeId)),
    ];

    let totalProporcion = amountsConDatos.length;

    let diferencialParsed = parseFloat(utilidadM);
    if (isNaN(diferencialParsed)) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Debes agregar el diferencial de margen!",
      });
      submittingRef.current = false;
      setValidaBoton(true);
      return;
    }

    if (piezasPorCaja == 0) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Debes agregar la proporcion de piezas por caja!",
      });
      submittingRef.current = false;
      setValidaBoton(true);
      return;
    }

    try {
      // Create any new items if needed
      let finalLineaId = selectedLinea;
      let finalMarcaId = selectedMarca;
      let finalFamiliaId = selectedFamilia;
      let finalColeccionId = selectedColeccion;
      let finalProveedorId = selectedProveedor;

      // Check if we need to create a new Linea
      if (isAddingLinea && newLineaName.trim()) {
        try {
          const lineaResponse = await axios.post(
            URL_LINEAS,
            { name: newLineaName.trim() },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );
          finalLineaId = lineaResponse.data._id;

          // Update the lineas list for future reference
          setLineas((prevLineas) => [...prevLineas, lineaResponse.data]);
        } catch (error) {
          console.error("Error creating new linea:", error);
          Swal.fire({
            icon: "error",
            title: "Error al crear nueva Linea",
            text: error.response?.data?.message || error.response?.data?.error || "Error desconocido",
          });
          submittingRef.current = false;
          setValidaBoton(true);
          return;
        }
      }

      // Check if we need to create a new Marca
      if (isAddingMarca && newMarcaName.trim()) {
        try {
          const marcaResponse = await axios.post(
            URL_MARCAS,
            { name: newMarcaName.trim() },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );
          finalMarcaId = marcaResponse.data._id;

          // Update the marcas list for future reference
          setMarcas((prevMarcas) => [...prevMarcas, marcaResponse.data]);
        } catch (error) {
          console.error("Error creating new marca:", error);
          Swal.fire({
            icon: "error",
            title: "Error al crear nueva Marca",
            text: error.response?.data?.message || error.response?.data?.error || "Error desconocido",
          });
          submittingRef.current = false;
          setValidaBoton(true);
          return;
        }
      }

      // Check if we need to create a new Familia
      if (isAddingFamilia && newFamiliaName.trim()) {
        try {
          const familiaResponse = await axios.post(
            URL_FAMILIAS,
            { name: newFamiliaName.trim() },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );
          finalFamiliaId = familiaResponse.data._id;

          // Update the familias list for future reference
          setFamilias((prevFamilias) => [
            ...prevFamilias,
            familiaResponse.data,
          ]);
        } catch (error) {
          console.error("Error creating new familia:", error);
          Swal.fire({
            icon: "error",
            title: "Error al crear nueva Familia",
            text: error.response?.data?.message || error.response?.data?.error || "Error desconocido",
          });
          submittingRef.current = false;
          setValidaBoton(true);
          return;
        }
      }

      // Check if we need to create a new Coleccion
      if (isAddingColeccion && newColeccionName.trim()) {
        try {
          const coleccionResponse = await axios.post(
            URL_COLECCIONES,
            { name: newColeccionName.trim() },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );
          finalColeccionId = coleccionResponse.data._id;

          // Update the colecciones list for future reference
          setColecciones((prevColecciones) => [
            ...prevColecciones,
            coleccionResponse.data,
          ]);
        } catch (error) {
          console.error("Error creating new coleccion:", error);
          Swal.fire({
            icon: "error",
            title: "Error al crear nueva Colección",
            text: error.response?.data?.message || error.response?.data?.error || "Error desconocido",
          });
          submittingRef.current = false;
          setValidaBoton(true);
          return;
        }
      }

      // Now create the article with the final IDs
      if (file == null) {
        await axios
          .post(
            URL_ARTICULOS,
            {
              codigo,
              nombre,
              piezasPorCaja,
              costoUSD,
              costoMX,
              venta,
              utilidadP: parseFloat(utilidadP) || 0,
              utilidadM: parseFloat(utilidadM) || 0,
              lista1: lista1,
              lista2: lista2,
              lista3: lista3,
              lista4: lista4,
              observaciones,
              lineas: finalLineaId,
              marcas: finalMarcaId,
              familias: finalFamiliaId,
              colecciones: finalColeccionId,
              proveedores: finalProveedorId,
              ano,
              EAN,
              RFID,
              precioEsp: "Si",
              colores: arrayColoresOfIds,
              tallas: arrayTallasOfIds,
              codigoSAT,
              codigoUnidad,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )

          .then((data) => {
            amountsConDatos.map((a) => {
              axios
                .post(
                  URL_ARTICULOS_PROPORCION,
                  {
                    articulos: data.data._id,
                    cantidad: a.cantidad,
                    colores: a.colorId,
                    tallas: a.sizeId,
                    EAN: `${codigo}${arrayColores.find(c => c.id === a.colorId)?.prefijo || ""}${arrayTallas.find(t => t.id === a.sizeId)?.name || ""}`,
                    RFID: generateEAN13(generateItemReference(
                      codigo,
                      arrayColores.find(c => c.id === a.colorId)?.name || "",
                      arrayTallas.find(t => t.id === a.sizeId)?.name || ""
                    )),
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  totalProporcion = totalProporcion - 1;
                  if (totalProporcion == 0) {
                    axios.post(
                      URL_LOGS,
                      {
                        tipo: "Crear Modelo",
                        detalle: `${nombre} ${codigo}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    );
                    Swal.fire("Good job!", "Creado con exito", `success`);
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  }
                })
                .catch((error) => {
                  console.log(error);
                  submittingRef.current = false;
                  setValidaBoton(true);
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
                  });
                });
            });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
            });
            console.log(error);
            submittingRef.current = false;
            setValidaBoton(true);
          });
      } else {
        await axios
          .post(
            URL_ARTICULOS,
            {
              codigo,
              nombre,
              piezasPorCaja,
              costoUSD,
              costoMX,
              venta,
              utilidadP: parseFloat(utilidadP) || 0,
              utilidadM: parseFloat(utilidadM) || 0,
              lista1: lista1,
              lista2: lista2,
              lista3: lista3,
              lista4: lista4,
              observaciones,
              lineas: finalLineaId,
              marcas: finalMarcaId,
              familias: finalFamiliaId,
              colecciones: finalColeccionId,
              proveedores: finalProveedorId,
              ano,
              EAN,
              RFID,
              precioEsp: "Si",
              colores: arrayColoresOfIds,
              tallas: arrayTallasOfIds,
              codigoSAT,
              codigoUnidad,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )

          .then((data) => {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("articulo", data.data._id);

            axios
              .post(URL_FILEPOST, formData, {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              })


            amountsConDatos.map((a) => {
              axios
                .post(
                  URL_ARTICULOS_PROPORCION,
                  {
                    articulos: data.data._id,
                    cantidad: a.cantidad,
                    colores: a.colorId,
                    tallas: a.sizeId,
                    EAN: `${codigo}${arrayColores.find(c => c.id === a.colorId)?.prefijo || ""}${arrayTallas.find(t => t.id === a.sizeId)?.name || ""}`,
                    RFID: generateEAN13(generateItemReference(
                      codigo,
                      arrayColores.find(c => c.id === a.colorId)?.name || "",
                      arrayTallas.find(t => t.id === a.sizeId)?.name || ""
                    )),
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  totalProporcion = totalProporcion - 1;
                  if (totalProporcion == 0) {
                    axios.post(
                      URL_LOGS,
                      {
                        tipo: "Crear Modelo",
                        detalle: `${nombre} ${codigo}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    );
                    Swal.fire("Good job!", "Creado con exito", `success`);
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  }
                })
                .catch((error) => {
                  console.log(error);
                  submittingRef.current = false;
                  setValidaBoton(true);
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
                  });
                });
            });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
            });
            console.log(error);
            submittingRef.current = false;
            setValidaBoton(true);
          });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
      });
      console.log(error);
    }
  };

  const handleInputChange = (sizeId, colorId, value, fieldType) => {
    const updatedAmounts = [...amounts];
    const existingEntryIndex = updatedAmounts.findIndex(
      (entry) => entry.sizeId === sizeId && entry.colorId === colorId
    );

    if (existingEntryIndex !== -1) {
      // Update existing entry
      if (fieldType === "amount") {
        updatedAmounts[existingEntryIndex].cantidad = value;
      } else if (fieldType === "ean") {
        updatedAmounts[existingEntryIndex].ean = value;
      }
    } else {
      // Create new entry with default values
      const newEntry = {
        sizeId: sizeId,
        colorId: colorId,
        tallas: sizeId,
        colores: colorId,
        cantidad: fieldType === "amount" ? value : 0,
        ean: fieldType === "ean" ? value : "",
      };
      updatedAmounts.push(newEntry);
    }

    setAmounts(updatedAmounts);

    // Calculate total for piezasPorCaja (only using the cantidad values)
    const totalAmount = updatedAmounts.reduce(
      (acc, curr) => acc + (parseFloat(curr.cantidad) || 0),
      0
    );

    setPiezasPorCaja(totalAmount);
  };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_articulos ? (
        <div
          className="card container col 10"
          style={{ paddingLeft: "30px", paddingRight: "30px" }}
        >
          <h3 align="center">Nuevo Modelo</h3>
          {/* <Get/> */}
          <Form onSubmit={saveArticulos}>
            <Row>
              <Col md={3}>
                <Label>Numero de Modelo</Label>
                <Input
                  type="text"
                  placeholder="Codigo"
                  value={codigo}
                  required
                  onChange={(e) => {
                    setCodigo(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Nombre</Label>
                <Input
                  type="text"
                  placeholder="Nombre"
                  value={nombre}
                  required
                  onChange={(e) => {
                    setNombre(e.target.value);
                  }}
                />
              </Col>

              <Col md={3}>
                <Label>Piezas Por Caja</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  value={piezasPorCaja}
                  required
                  disabled
                />
              </Col>
              <Col md={3}>
                <Label>Código de barras (EAN)</Label>
                <Input
                  type="text"
                  placeholder="Código de barras"
                  value={EAN}
                  required
                  disabled
                />
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <Label>RFID</Label>
                <Input
                  type="text"
                  placeholder="RFID"
                  value={RFID}
                  disabled
                />
              </Col>
            </Row>

            <Row>
              <Col md={3}>
                <Label>FOB USD</Label>
                <Input
                  type="text"
                  placeholder="FOB USD"
                  value={costoUSD}
                  required
                  onChange={(e) => {
                    setCostoUSD(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Costo MX</Label>
                <Input
                  type="text"
                  placeholder="Costo MX"
                  value={costoMX}
                  required
                  onChange={(e) => {
                    setCostoMX(e.target.value);
                  }}
                />
              </Col>

              <Col md={3}>
                <Label>Utilidad %</Label>
                <Input
                  type="number"
                  placeholder="Utilidad %"
                  value={utilidadP}
                  required
                  onChange={(e) => {
                    const value = parseFloat(e.target.value) || 0;
                    SetUtilidadP(value);
                    setLastChanged("utilidadP");
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Utilidad por monto </Label>
                <Input
                  type="number"
                  placeholder="Utilidad por monto"
                  value={utilidadM}
                  onChange={(e) => {
                    const value = parseFloat(e.target.value) || 0;
                    setUtilidadM(value);
                    setLastChanged("utilidadM");
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Venta</Label>
                <Input
                  type="text"
                  placeholder="Venta"
                  value={venta}
                  required
                  onChange={(e) => {
                    setVenta(e.target.value);
                  }}
                />
              </Col>

              <Col md={3}>
                <Label>Observaciones</Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Codigo SAT</Label>
                <Input
                  type="select"
                  placeholder="CodigoSAT"
                  value={codigoSAT}
                  required
                  onChange={(e) => {
                    setCodigoSAT(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="53101604">53101604 BLUSAS MUJER</option>
                  <option value="53102002">53102002 VESTIDOS, FALDAS, JUMPER</option>
                  <option value="53101504">53101504 PANTALONES MUJER</option>
                  <option value="53101804">53101804 CHAMARRAS MUJER</option>
                  <option value="53101704">53101704 SWEATER MUJER</option>
                  <option value="53103100">53103100 CHALECOS</option>
                  <option value="53102800">53102800 TRAJES DE BAÑO</option>
                  <option value="53101602">53101602 CAMISAS HOMBRE</option>
                  <option value="53101502">53101502 PANTALON HOMBRE</option>
                  <option value="52121500">52121500 COBIJA</option>
                  <option value="53101904">53101904 CONJUNTO</option>
                  <option value="53102304">53102304 SILICON BRA</option>
                  <option value="53102307">53102307 BODY TAPE</option>
                  <option value="53102501">53102501 CINTO</option>
                  <option value="53102502">53102502 BUFANDA/PAÑOLETA</option>
                  <option value="53102503">53102503 SOMBRERO</option>
                  <option value="53102516">53102516 GORRO/GORRA</option>
                  <option value="53121601">53121601 BOLSO/CARTERA</option>
                  <option value="53131633">53131633 PINZAS, BROCHES, PASADORES</option>
                  <option value="54101602">54101602 COLLAR</option>
                  <option value="53101601">53101601 PULSERA/BRAZALETE</option>
                  <option value="54101604">54101604 ARETE</option>
                  <option value="53101804">53101804 SACO</option>
                </Input>
              </Col>
              <Col md={3}>
                <Label>Codigo Unidad</Label>
                <Input
                  type="string"
                  placeholder="CodigoUnidad"
                  value={codigoUnidad}
                  required
                  onChange={(e) => {
                    setCodigoUnidad(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              {/* Linea */}
              <Col md={3} className="mb-3">
                <Label className="mr-sm-2">Linea</Label>
                <div className="d-flex align-items-center">
                  {!isAddingLinea ? (
                    <>
                      <div style={{ width: "calc(100% - 40px)" }}>
                        <Input
                          type="select"
                          value={selectedLinea}
                          required
                          onChange={(e) => {
                            setSelectedLinea(e.target.value);
                          }}
                          style={{ width: "100%" }}
                        >
                          <option value="0">Selecciona una Linea</option>
                          {lineas
                            .sort((a, b) => (a.name > b.name ? 1 : -1))
                            .map((a) => {
                              return <option key={a._id} value={a._id}>{a.name}</option>;
                            })}
                        </Input>
                      </div>
                      <Button
                        color="success"
                        size="sm"
                        type="button"
                        style={{
                          marginLeft: "10px",
                          borderRadius: "4px",
                          padding: "6px 10px",
                        }}
                        onClick={() => {
                          setIsAddingLinea(true);
                        }}
                      >
                        <i className="fas fa-plus"></i>
                      </Button>
                    </>
                  ) : (
                    <>
                      <div style={{ width: "calc(100% - 40px)" }}>
                        <Input
                          type="text"
                          value={newLineaName}
                          required
                          placeholder="Nueva Linea"
                          onChange={(e) => {
                            setNewLineaName(e.target.value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" && newLineaName.trim()) {
                              setIsAddingLinea(false);
                            }
                          }}
                          style={{ width: "100%" }}
                        />
                      </div>
                      <Button
                        color="secondary"
                        size="sm"
                        type="button"
                        style={{
                          marginLeft: "10px",
                          borderRadius: "4px",
                          padding: "6px 10px",
                        }}
                        onClick={() => {
                          setIsAddingLinea(false);
                          setNewLineaName("");
                        }}
                      >
                        <i className="fas fa-times"></i>
                      </Button>
                    </>
                  )}
                </div>
              </Col>

              {/* Marca */}
              <Col md={3} className="mb-3">
                <Label className="mr-sm-2">Marca</Label>
                <div className="d-flex align-items-center">
                  {!isAddingMarca ? (
                    <>
                      <div style={{ width: "calc(100% - 40px)" }}>
                        <Input
                          type="select"
                          value={selectedMarca}
                          required
                          onChange={(e) => {
                            setSelectedMarca(e.target.value);
                          }}
                          style={{ width: "100%" }}
                        >
                          <option value="0">Selecciona una Marca</option>
                          {marcas
                            .sort((a, b) => (a.name > b.name ? 1 : -1))
                            .map((a) => {
                              return <option key={a._id} value={a._id}>{a.name}</option>;
                            })}
                        </Input>
                      </div>
                      <Button
                        color="success"
                        size="sm"
                        type="button"
                        style={{
                          marginLeft: "10px",
                          borderRadius: "4px",
                          padding: "6px 10px",
                        }}
                        onClick={() => {
                          setIsAddingMarca(true);
                        }}
                      >
                        <i className="fas fa-plus"></i>
                      </Button>
                    </>
                  ) : (
                    <>
                      <div style={{ width: "calc(100% - 40px)" }}>
                        <Input
                          type="text"
                          value={newMarcaName}
                          required
                          placeholder="Nueva Marca"
                          onChange={(e) => {
                            setNewMarcaName(e.target.value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" && newMarcaName.trim()) {
                              setIsAddingMarca(false);
                            }
                          }}
                          style={{ width: "100%" }}
                        />
                      </div>
                      <Button
                        color="secondary"
                        size="sm"
                        type="button"
                        style={{
                          marginLeft: "10px",
                          borderRadius: "4px",
                          padding: "6px 10px",
                        }}
                        onClick={() => {
                          setIsAddingMarca(false);
                          setNewMarcaName("");
                        }}
                      >
                        <i className="fas fa-times"></i>
                      </Button>
                    </>
                  )}
                </div>
              </Col>

              {/* Familia */}
              <Col md={3} className="mb-3">
                <Label className="mr-sm-2">Familia</Label>
                <div className="d-flex align-items-center">
                  {!isAddingFamilia ? (
                    <>
                      <div style={{ width: "calc(100% - 40px)" }}>
                        <Input
                          type="select"
                          value={selectedFamilia}
                          required
                          onChange={(e) => {
                            setSelectedFamilia(e.target.value);
                          }}
                          style={{ width: "100%" }}
                        >
                          <option value="0">Selecciona una Familia</option>
                          {familias
                            .sort((a, b) => (a.name > b.name ? 1 : -1))
                            .map((a) => {
                              return <option key={a._id} value={a._id}>{a.name}</option>;
                            })}
                        </Input>
                      </div>
                      <Button
                        color="success"
                        size="sm"
                        type="button"
                        style={{
                          marginLeft: "10px",
                          borderRadius: "4px",
                          padding: "6px 10px",
                        }}
                        onClick={() => {
                          setIsAddingFamilia(true);
                        }}
                      >
                        <i className="fas fa-plus"></i>
                      </Button>
                    </>
                  ) : (
                    <>
                      <div style={{ width: "calc(100% - 40px)" }}>
                        <Input
                          type="text"
                          value={newFamiliaName}
                          required
                          placeholder="Nueva Familia"
                          onChange={(e) => {
                            setNewFamiliaName(e.target.value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" && newFamiliaName.trim()) {
                              setIsAddingFamilia(false);
                            }
                          }}
                          style={{ width: "100%" }}
                        />
                      </div>
                      <Button
                        color="secondary"
                        size="sm"
                        type="button"
                        style={{
                          marginLeft: "10px",
                          borderRadius: "4px",
                          padding: "6px 10px",
                        }}
                        onClick={() => {
                          setIsAddingFamilia(false);
                          setNewFamiliaName("");
                        }}
                      >
                        <i className="fas fa-times"></i>
                      </Button>
                    </>
                  )}
                </div>
              </Col>
            </Row>
            <Row>
              {/* Coleccion */}
              <Col md={3} className="mb-3">
                <Label className="mr-sm-2">Coleccion</Label>
                <div className="d-flex align-items-center">
                  {!isAddingColeccion ? (
                    <>
                      <div style={{ width: "calc(100% - 40px)" }}>
                        <Input
                          type="select"
                          value={selectedColeccion}
                          required
                          onChange={(e) => {
                            setSelectedColeccion(e.target.value);
                          }}
                          style={{ width: "100%" }}
                        >
                          <option value="0">Selecciona una Coleccion</option>
                          {colecciones
                            .sort((a, b) => (a.name > b.name ? 1 : -1))
                            .map((a) => {
                              return <option key={a._id} value={a._id}>{a.name}</option>;
                            })}
                        </Input>
                      </div>
                      <Button
                        color="success"
                        size="sm"
                        type="button"
                        style={{
                          marginLeft: "10px",
                          borderRadius: "4px",
                          padding: "6px 10px",
                        }}
                        onClick={() => {
                          setIsAddingColeccion(true);
                        }}
                      >
                        <i className="fas fa-plus"></i>
                      </Button>
                    </>
                  ) : (
                    <>
                      <div style={{ width: "calc(100% - 40px)" }}>
                        <Input
                          type="text"
                          value={newColeccionName}
                          required
                          placeholder="Nueva Coleccion"
                          onChange={(e) => {
                            setNewColeccionName(e.target.value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" && newColeccionName.trim()) {
                              setIsAddingColeccion(false);
                            }
                          }}
                          style={{ width: "100%" }}
                        />
                      </div>
                      <Button
                        color="secondary"
                        size="sm"
                        type="button"
                        style={{
                          marginLeft: "10px",
                          borderRadius: "4px",
                          padding: "6px 10px",
                        }}
                        onClick={() => {
                          setIsAddingColeccion(false);
                          setNewColeccionName("");
                        }}
                      >
                        <i className="fas fa-times"></i>
                      </Button>
                    </>
                  )}
                </div>
              </Col>

              {/* Año */}
              <Col md={3} className="mb-3">
                <Label>Año</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={ano}
                  required
                  onChange={(e) => {
                    setAno(e.target.value);
                  }}
                >
                  <option value="0">Selecciona un Año</option>
                  {years.map((a) => {
                    return <option key={a} value={a}>{a}</option>;
                  })}
                </Input>
              </Col>

              {/* Proveedor */}
              <Col md={3} className="mb-3">
                <Label className="mr-sm-2">Proveedor</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedProveedor}
                  required
                  onChange={(e) => {
                    setSelectedProveedor(e.target.value);
                  }}
                >
                  <option value="0">Selecciona un Proveedor</option>
                  {proveedores
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1
                    )
                    .map((a) => {
                      return (
                        <option key={a._id} value={a._id}>{a.nombre_comercial}</option>
                      );
                    })}
                </Input>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Label>Foto</Label>
                <Input
                  type="file"
                  onChange={(e) => {
                    setFile(e.target.files[0]);
                  }}
                />
              </Col>
            </Row>
            <h4>Precios de Venta</h4>
            <Row>
              <Col md={3}>
                <Label>Lista 1</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  value={lista1}
                  required
                  onChange={(e) => {
                    setLista1(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Lista 2</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  value={lista2}
                  required
                  onChange={(e) => {
                    setLista2(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Lista 3</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  value={lista3}
                  required
                  onChange={(e) => {
                    setLista3(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Lista 4</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  value={lista4}
                  required
                  onChange={(e) => {
                    setLista4(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Agregar Colores
                </Label>
                <br />
                <Button
                  color="success"
                  id="Colores"
                  type="button"
                  onClick={(e) => toggleColores()}
                >
                  <i className="fas fa-palette fa-2x "></i>
                </Button>
              </Col>

              <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Agregar Tallas
                </Label>
                <br />
                <Button
                  color="success"
                  id="Tallas"
                  type="button"
                  onClick={(e) => toggleTallas()}
                >
                  <i className="fas fa-ruler-horizontal fa-2x "></i>
                </Button>
              </Col>
            </Row>
            <br />
            <Row className="w-full">
              <div className="bg-white shadow-md rounded-lg overflow-hidden border border-gray-200 w-full">
                <div className="p-6 bg-gray-50">
                  <Label className="text-xl font-semibold text-gray-800 mb-4 block">
                    Proporcion
                  </Label>

                  {/* Enhanced scrollable container */}
                  <div
                    style={{
                      width: "100%",
                      overflowX: "auto",
                      WebkitOverflowScrolling: "touch",
                      display: "block",
                      maxWidth: "100%",
                    }}
                  >
                    <table
                      style={{
                        minWidth: "1200px",
                        width: "100%",
                        borderCollapse: "collapse",
                      }}
                    >
                      <thead>
                        {/* Size Names Row */}
                        <tr>
                          <th
                            className="border py-3 px-4 text-center font-medium text-gray-600"
                            style={{
                              width: "200px",
                              position: "sticky",
                              left: 0,
                              zIndex: 10,
                              backgroundColor: "white",
                              color: "gray",
                            }}
                          ></th>
                          {[...arrayTallas]
                            .sort((a, b) => {
                              const indexA = customSizeOrder.indexOf(a.name);
                              const indexB = customSizeOrder.indexOf(b.name);
                              if (indexA === -1 && indexB === -1) return 0;
                              if (indexA === -1) return 1;
                              if (indexB === -1) return -1;
                              return indexA - indexB;
                            })
                            .map((size) => (
                              <th
                                key={size.id}
                                className="border py-2 px-4 text-center font-medium text-gray-600"
                                colSpan="3"
                              >
                                <div
                                  className="text-lg border border-gray-300 rounded-t-lg py-2 bg-gray-100"
                                  style={{ color: "gray" }}
                                >
                                  {size.name}
                                </div>
                              </th>
                            ))}
                        </tr>

                        {/* Column Headers Row */}
                        <tr>
                          <th
                            className="border py-2 px-4 text-left font-medium text-gray-500"
                            style={{
                              position: "sticky",
                              left: 0,
                              zIndex: 10,
                              backgroundColor: "white",
                              color: "gray",
                            }}
                          ></th>
                          {[...arrayTallas]
                            .sort((a, b) => {
                              const indexA = customSizeOrder.indexOf(a.name);
                              const indexB = customSizeOrder.indexOf(b.name);
                              if (indexA === -1 && indexB === -1) return 0;
                              if (indexA === -1) return 1;
                              if (indexB === -1) return -1;
                              return indexA - indexB;
                            })
                            .map((size) => (
                              <React.Fragment key={`header-${size.id}`}>
                                <th
                                  className="border py-2 px-1 text-center text-xs font-medium text-gray-500 bg-gray-50"
                                  style={{
                                    width: "80px",
                                    color: "gray",
                                  }}
                                >
                                  CANTIDAD
                                </th>
                                <th
                                  className="border py-2 px-3 text-center text-xs font-medium text-gray-500 bg-gray-50"
                                  style={{
                                    width: "240px",
                                    color: "gray",
                                  }}
                                >
                                  CÓDIGO DE BARRAS
                                </th>
                                <th
                                  className="border py-2 px-3 text-center text-xs font-medium text-gray-500 bg-gray-50"
                                  style={{
                                    width: "240px",
                                    color: "gray",
                                  }}
                                >
                                  RFID
                                </th>
                              </React.Fragment>
                            ))}
                        </tr>
                      </thead>
                      <tbody>
                        {arrayColores.map((color, colorIndex) => (
                          <tr
                            key={color.id}
                            className={`${colorIndex % 2 === 0 ? "bg-white" : "bg-gray-50"
                              } hover:bg-gray-100 transition-colors`}
                          >
                            <td
                              className="border py-3 px-4 text-gray-700 font-medium"
                              style={{
                                position: "sticky",
                                left: 0,
                                zIndex: 5,
                                backgroundColor:
                                  colorIndex % 2 === 0 ? "white" : "#f9fafb",
                                color: "gray",
                              }}
                            >
                              <div className="flex items-center">
                                <div
                                  className="w-4 h-4 rounded-full mr-3"
                                  style={{
                                    backgroundColor: color.name.toLowerCase(),
                                    color: "gray",
                                  }}
                                ></div>
                                <span className="uppercase">{color.name}</span>
                              </div>
                            </td>
                            {[...arrayTallas]
                              .sort((a, b) => {
                                const indexA = customSizeOrder.indexOf(a.name);
                                const indexB = customSizeOrder.indexOf(b.name);
                                if (indexA === -1 && indexB === -1) return 0;
                                if (indexA === -1) return 1;
                                if (indexB === -1) return -1;
                                return indexA - indexB;
                              })
                              .map((size) => {
                                const entry = amounts.find(
                                  (entry) =>
                                    entry.sizeId === size.id &&
                                    entry.colorId === color.id
                                );
                                const cantidad = entry?.cantidad || 0;
                                const ean = `${codigo}${color.prefijo || ""}${size.name}`;
                                const rfid = generateEAN13(generateItemReference(codigo, color.name, size.name));

                                return (
                                  <React.Fragment
                                    key={`${color.id}-${size.id}`}
                                  >
                                    <td className="border py-2 px-1 text-center">
                                      <input
                                        type="number"
                                        min="0"
                                        step="any"
                                        value={cantidad}
                                        onChange={(e) =>
                                          handleInputChange(
                                            size.id,
                                            color.id,
                                            e.target.value,
                                            "amount"
                                          )
                                        }
                                        className="w-full border border-gray-300 rounded-lg p-2 text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        placeholder="0"
                                      />
                                    </td>
                                    <td className="border py-2 px-3 text-center">
                                      <input
                                        type="text"
                                        value={ean}
                                        disabled
                                        className="w-full border border-gray-200 rounded-lg p-2 text-center bg-gray-100 text-gray-500 cursor-not-allowed"
                                        title="EAN"
                                      />
                                    </td>
                                    <td className="border py-2 px-3 text-center">
                                      <input
                                        type="text"
                                        value={rfid}
                                        disabled
                                        className="w-full border border-gray-200 rounded-lg p-2 text-center bg-gray-100 text-gray-500 cursor-not-allowed"
                                        title="RFID"
                                      />
                                    </td>
                                  </React.Fragment>
                                );
                              })}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </Row>
            <br />
            {validaBoton &&
              arrayColores.length > 0 &&
              arrayTallas.length > 0 &&
              amounts.some((entry) => entry.cantidad > 0) ? (
              <Button type="submit" className="btn btn-success" tabIndex={-1}>
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" tabIndex={-1} disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoArticulos"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />

          <Modal size="lg" isOpen={modalColores} toggle={toggleColores}>
            <ModalHeader toggle={toggleColores}>
              <h4>Colores del Modelo {nombre}</h4>
            </ModalHeader>
            <ModalBody>
              {/* Show available colores (unchecked) */}
              {colores
                .filter(
                  (color) =>
                    !arrayColores.some((selected) => selected.id === color._id)
                )
                .sort((a, b) => (a.name > b.name ? 1 : -1))
                .map((a) => {
                  return (
                    <table key={a._id}>
                      <tbody>
                        <tr>
                          <td>
                            <Input
                              type="checkbox"
                              key={a._id}
                              onChange={(e) => {
                                coloresSeleccionados(
                                  e.currentTarget.checked,
                                  a
                                );
                              }}
                              className="subMenu"
                            />
                            <h5 className="subMenuTitulo">{a.name}</h5>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  );
                })}

              {/* Show selected colores at the bottom */}
              {arrayColores.length > 0 && (
                <>
                  <hr style={{ margin: "20px 0" }} />
                  <h6 style={{ fontWeight: "bold" }}>Colores Seleccionados:</h6>
                  {arrayColores
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((selectedColor) => (
                      <table key={`selected-${selectedColor.id}`}>
                        <tbody>
                          <tr>
                            <td>
                              <Input
                                type="checkbox"
                                checked={true}
                                onChange={(e) => {
                                  coloresSeleccionados(
                                    e.currentTarget.checked,
                                    selectedColor
                                  );
                                }}
                                className="subMenu"
                              />
                              <h5 className="subMenuTitulo">
                                {selectedColor.name}
                              </h5>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    ))}
                </>
              )}
            </ModalBody>
          </Modal>

          <Modal size="lg" isOpen={modalTallas} toggle={toggleTallas}>
            <ModalHeader toggle={toggleTallas}>
              <h4>Tallas del Modelo {nombre}</h4>
            </ModalHeader>
            <ModalBody>
              {/* Show available tallas (unchecked) */}
              {tallas
                .filter(
                  (talla) =>
                    !arrayTallas.some((selected) => selected.id === talla._id)
                )
                .sort((a, b) => {
                  const indexA = customSizeOrder.indexOf(a.name);
                  const indexB = customSizeOrder.indexOf(b.name);

                  if (indexA === -1 && indexB === -1) return 0;
                  if (indexA === -1) return 1;
                  if (indexB === -1) return -1;

                  return indexA - indexB;
                })
                .map((a) => {
                  return (
                    <table key={a._id}>
                      <tbody>
                        <tr>
                          <td>
                            <Input
                              type="checkbox"
                              key={a._id}
                              onChange={(e) => {
                                tallasSeleccionados(e.currentTarget.checked, a);
                              }}
                              className="subMenu"
                            />
                            <h5 className="subMenuTitulo">{a.name}</h5>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  );
                })}

              {/* Show selected tallas at the bottom */}
              {arrayTallas.length > 0 && (
                <>
                  <hr style={{ margin: "20px 0" }} />
                  <h6 style={{ fontWeight: "bold" }}>Tallas Seleccionadas:</h6>
                  {arrayTallas
                    .sort((a, b) => {
                      const indexA = customSizeOrder.indexOf(a.name);
                      const indexB = customSizeOrder.indexOf(b.name);

                      if (indexA === -1 && indexB === -1) return 0;
                      if (indexA === -1) return 1;
                      if (indexB === -1) return -1;

                      return indexA - indexB;
                    })
                    .map((selectedTalla) => (
                      <table key={`selected-${selectedTalla.id}`}>
                        <tbody>
                          <tr>
                            <td>
                              <Input
                                type="checkbox"
                                checked={true}
                                onChange={(e) => {
                                  tallasSeleccionados(
                                    e.currentTarget.checked,
                                    selectedTalla
                                  );
                                }}
                                className="subMenu"
                              />
                              <h5 className="subMenuTitulo">
                                {selectedTalla.name}
                              </h5>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    ))}
                </>
              )}
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default ArticulosCreate;